import React from 'react';
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Highlight from "@tiptap/extension-highlight";
import Link from "@tiptap/extension-link";
import { ToolBar} from "./toolbar"
import "./styles.css";

export type RichEditorProps = {
  initialContent: string;
  setPostContent: Function;
};

export function RichEditor({ initialContent, setPostContent }: RichEditorProps) {

    const extensions = [
        StarterKit,
		Link,
		Highlight
    ]

	const editor = useEditor({
		extensions,
		content: initialContent,
		onUpdate: ({ editor }) => {
			const content = editor.getHTML()
            setPostContent(content)
        },
		injectCSS: false
	});

  	return (
		<div id="rich-editor">
			<ToolBar editor={editor} />
			<div className="editor-wrapper">
				<EditorContent editor={editor}/>
			</div>
		</div>
  	);
}
